//@ts-check
import { Flex, ProgressCircle } from '@adobe/react-spectrum';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { parseFromLocalStorage } from '@exchange-frontends/utils';

import useEnterpriseEntitlements from '../../../../actions/entitlementApi/selectors/ecAppsList/useEnterpriseEntitlements';
import { DEFAULT_ABD_OPTIONS } from '../../../../actions/myxchngApi/selectors/useAppBuilderAppsList';
import useCcEntitlements from '../../../../actions/myxchngApi/selectors/useCcEntitlements';
import useXrAppBuilderApps from '../../../../actions/myxchngApi/selectors/useXrAppBuilderApps';
import useSpFeatureFlag from '../../../../actions/utilApi/selectors/useSpFeatureFlag';
import { useStore } from '../../store';
import { TABS_DEFINITION } from '../../utils/TabsDefinition';

const selectedOrgSelector = (state) => state.selectedOrg;

export const DefaultTab = () => {
  const selectedOrg = useStore(selectedOrgSelector);
  const spFeatureFlagEnabled = useSpFeatureFlag().data;
  const ccEntitlementsQuery = useCcEntitlements();
  const appBuilderAppsQuery = useEnterpriseEntitlements(DEFAULT_ABD_OPTIONS);
  const xrAppBuilderAppsQuery = useXrAppBuilderApps();
  const spEntitlementsQuery = useEnterpriseEntitlements({
    enabled: spFeatureFlagEnabled,
    appType: 'S2S',
    pageSize: 20,
  });

  const orgs = parseFromLocalStorage('orgs');
  const hasOrgs = orgs?.length > 0;
  const isEnterpriseOrg = selectedOrg?.type === 'entp';
  const isLoadingAppBuilderEntitlements = appBuilderAppsQuery.isLoading || xrAppBuilderAppsQuery.isLoading;
  const isLoadingSpEntitlements = spEntitlementsQuery.isLoading && spFeatureFlagEnabled;
  const isLoadingEntpEntitlements = isEnterpriseOrg && (isLoadingAppBuilderEntitlements || isLoadingSpEntitlements);
  const missingData = !selectedOrg || ccEntitlementsQuery.isLoading || isLoadingEntpEntitlements;
  const isLoading = missingData && hasOrgs;

  if (isLoading) {
    return (
      <Flex justifyContent="center" flexGrow={1} alignItems="center">
        <ProgressCircle isIndeterminate size="L" />
      </Flex>
    );
  }

  const hasAppBuilderApps =
    appBuilderAppsQuery.data?.enterpriseEntitlements?.length > 0 || xrAppBuilderAppsQuery.data?.apps?.length > 0;
  const hasCCApps = ccEntitlementsQuery.data?.entitlements?.length > 0;
  const hasSpApps = spEntitlementsQuery?.data?.enterpriseEntitlements?.length > 0;
  const hasApps = hasCCApps || hasAppBuilderApps || (spFeatureFlagEnabled && hasSpApps);

  const paths = [
    {
      condition: spFeatureFlagEnabled && isEnterpriseOrg && (hasSpApps || !hasApps),
      path: TABS_DEFINITION.INTEGRATIONS.computePath(TABS_DEFINITION.INTEGRATIONS.path),
    },
    {
      condition: isEnterpriseOrg && (hasAppBuilderApps || !hasApps),
      path: TABS_DEFINITION.APP_BUILDER.computePath(TABS_DEFINITION.APP_BUILDER.path),
    },
    {
      path: TABS_DEFINITION.CC_PLUGINS.path,
      // FALLBACK: make sure a path is always returned
      condition: true,
    },
  ];

  const defaultPath = paths.find((tab) => tab.condition).path;

  return <Navigate replace to={defaultPath} />;
};
